
import { useState, useRef } from "react";
import { txb, txbb, txtb } from "../common_components/text_style_components";

/**
 * This will show UI for user area text
 * and also Input by AI Interviewer like details of parking lot
 * 3-d array which represents blueprint of parking lot
 */
function UserAIInputAreaUI({ showUserArea=true, setShowUserArea,
   interviewerInput={}, setUserText }) {
  //const[, setShowUserArea]=useState(false)
  const[text, setText]=useState("")
  
  function updateText(newText){
    setText(newText)
    setUserText(newText)
  }

    return (
    <div className="flex flex-col w-full  ">
    <div className="flex flex-row w-full">
      {/* Left Button */}
      <button
        className={`flex-1 p-2 m-2 rounded-lg text-white ${
          showUserArea ? "bg-purple-500" : "bg-gray-500"
        }`}
        onClick={() => setShowUserArea(true)}
      >
        User Area
      </button>

      {/* Right Button */}
      <button
        className={`flex-1 p-2 m-2 rounded-lg text-white ${
          showUserArea ? "bg-gray-500" : "bg-purple-500"
        }`}
        onClick={() => setShowUserArea(false)}
      >
        Interviewer Input
      </button>
    </div>  

    { showUserArea &&
     <div className="flex flex-col  ">  
       {/* whitespace-pre-line is required so that multiple lines appear correctly in placeholder */} 
      <textarea
        className="w-full h-64 p-2 border 
         border-gray-300 rounded-md overflow-auto resize-none
         whitespace-pre-line
         placeholder:text-xl placeholder:text-gray-600"
        value={text}
        placeholder=" 
         Type requirements, class names and other details here.
        -------
         Whatever you type in this area will be used for final evaluation.
        -------
         So, don't skip any details."
        onChange={(e) => updateText(e.target.value)}
      />
      </div>
    }
    {
      !showUserArea &&
      <div>
          
      </div>
    }
      </div>
    );
  }

/**
 * This will show UI for user area text
 * where user will write method signature for requirements,
 * class names etc
 * @param rows number of visible rows i.e.height of text area, default is 6
 * @param maxChars maximum number of characters that can be entered in text area
 *  default is 10000
 * @param showCounterAfterChars show character counter after these many chars
 * so that users get the idea that there is a character limit
 * default is 1500 , e.g 5001/10000
 */
function UserAreaUI({setUserText , rows=6, 
  maxChars=10000, showCounterAfterChars=5000
}) {
 //const[, setShowUserArea]=useState(false)
 const[text, setText]=useState("")
 
 function updateText(newText){
   setText(newText)
   setUserText(newText)
 }

   return (
   <div className="flex flex-col mt-4 w-full  ">
   <div className="flex flex-row w-full">
     {/* Left Button */}
     <div className="text-xl font-mono  text-gray-700">
       User area {txtb("(Shared doc) ")}: &nbsp; &nbsp; <span className=" text-gray-700">
         For {txb("Code, ")} {txb("Method Signatures ")}  etc.
       </span>
     </div>

   </div>  

   {
    <div className="flex flex-col  ">  
      {/* whitespace-pre-line is required so that multiple lines appear correctly in placeholder */} 
     <textarea
       className="w-full p-2 border 
        border-gray-300 rounded-md overflow-auto resize-none
        whitespace-pre-line
        placeholder: placeholder:text-gray-600 placeholder:leading-8
         placeholder:text-sm"
       value={text}
       rows={rows}
       placeholder=" 
        Type requirements, METHOD SIGNATURES, class names, CODE,  and other details here.
         -------
      Whatever you type in this area will be used for &nbsp; ---> &nbsp; Final Evaluation.
         -------
        DO NOT Delete anything from here even when section changes."
       onChange={(e) => updateText(e.target.value)}
     />
     {text.length > showCounterAfterChars && (
        <div className="text-sm text-gray-500 text-right mr-4">
          {text.length} / {maxChars} characters
        </div>)}
     </div>
   }
     </div>
   );
}  
export {UserAIInputAreaUI, UserAreaUI};